<template>
    <modal
           name="NoticePopup"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto"
           width="50%"  style="paddig-top:20px;">
        <div class="popupcontainer container">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="close()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>
                    {{notice.title}}
                </h4>
            </div>
            <div class="row" style="padding: 1em;">
                <span v-html="notice.content" style="margin-bottom: 100px;"/>
            </div>
            <div class="row modalFooter">
                <div class="col text-left">
                    <router-link :to="{name : 'noticeShow', params : { id : notice.id }}">자세히 보기</router-link>
                </div>
                <div class="col text-right">
                    <input type="checkbox" id="checkbox" v-model="noShowPopup" @click="rememberShow()">
                    <label for="checkbox" @click="rememberShow()"> &nbsp;하루 동안 보지않기</label>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        name: "noticePopup",
        data() {
            return {
                myAwesomeModal: false,
                notice : {},
                noShowPopup : false,
            }
        },
        methods: {
            getNotice() {
                let me = this;

                this.axios.get(process.env.VUE_APP_NOTICE_API_URL + `/popup`)
                    .then(function (res) {
                        me.notice = res.data;
                        if(res.data && !me.noShowPopup)
                            me.$modal.show('NoticePopup');
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            rememberShow() {
                this.$cookies.set('noShowPopup',"true","1d");

                this.$modal.hide('NoticePopup')
            },
            close() {
                this.$modal.hide('NoticePopup')
            }
        },
        mounted() {
                this.getNotice();
        },
        created() {
            if(!!this.$cookies.get('noShowPopup')) {
                this.noShowPopup = this.$cookies.get('noShowPopup');
            }
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        max-height:600px;
        border-radius: 5px;
        background: #F7F7F7;
    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
    .modalFooter {
        position: absolute;
        bottom: 0;
        width: 100%;
        background-color: #F7F7F7;
    }
</style>